/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_PreviewInvoicesRequest = {
    /**
     * ChildIDs - optional list of child IDs to filter by
     */
    child_ids?: Array<string>;
    /**
     * ChildcareIDs - optional list of childcare IDs to filter by
     */
    childcare_ids?: Array<string>;
    /**
     * ContractIDs to preview (optional, all if empty)
     */
    contract_ids?: Array<string>;
    /**
     * ContractType - optional contract type filter ("regular", "subsidised", "all")
     */
    contract_type?: billing_PreviewInvoicesRequest.contract_type;
    /**
     * GroupIDs - optional list of group IDs to filter by
     */
    group_ids?: Array<string>;
    /**
     * Month for preview
     */
    month: number;
    /**
     * Year for preview (floor is services.MinBillingYear; literal required in tag)
     */
    year: number;
};
export namespace billing_PreviewInvoicesRequest {
    /**
     * ContractType - optional contract type filter ("regular", "subsidised", "all")
     */
    export enum contract_type {
        REGULAR = 'regular',
        SUBSIDISED = 'subsidised',
        ALL = 'all',
    }
}

